elapsedInteractionTime